import React from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";

import './AllAnunturi.css'
import JudeteDataService from '../services/JudeteDataService';

const ORDER_BY_MP_PRICE = 1;
const ORDER_BY_SURFACE = 2;
const ORDER_BY_TOTAL_PRICE = 3;
const ORDER_BY_ID = 4;
const ORDER_BY_LOCALITATE = 5;

class TotaluriJudet extends React.Component {

    render() {
        const isMobile = window.innerWidth < 800;
        if ( isMobile ) {
            return (
                <div id="totaluri-judet-container" className="unselectable">
                    <div id="title">{this.props.jud.toUpperCase()} - Toate licitatiile</div>
                    <div id="desc">Totaluri in baza de date pentru judet:</div>
                    <div id="anunturi">{ this.props.anunturiCount }  Anunturi</div>
                    <div id="licitatii">{ this.props.licitatiiCount } Licitatii</div>
                </div>
            )
        }
        else {
            return (
                <div id="totaluri-wrapper-desktop">
                    <div id="totaluri-judet-container-desktop">

                        <div id="title">
                            <span>{this.props.jud.toUpperCase()}</span>
                            { this.props.licitatie && <span> - TOATE LICITATIILE</span> }
                            { !this.props.licitatie && <span> - TOATE ANUNTURILE</span> }
                        </div>
                        

                        <div id="desc">Totaluri in baza de date pentru judet:</div>
                        <div id="anunturi">{ this.props.anunturiCount }  Anunturi</div>
                        <div id="licitatii">{ this.props.licitatiiCount } Licitatii</div>

                        { this.props.for === 'teren' && <img className='img-totaluri terenuri' src='/img/terrain-dark.svg' alt="terrain logo" /> }
                        { this.props.for === 'casa' && <img className='img-totaluri' src='/img/case-dark.svg' alt="house logo" /> }
                    </div>
                </div>
            )
        }
    }
}

class Salvata extends React.Component {
    render() {
        if ( this.props.salvata === 1 ) {
            return (
                <img className="interesanta-smaller" src="/img/interesanta.svg" alt="interesting" />
            )
        }
        else {
            return (
                <span></span>
            )
        }
    }
}

class Raportata extends React.Component {
    render() {
        if ( this.props.raportata === 1 ) {
            return (
                <img className="interesanta-smaller" src="/img/raportata.svg" alt="reported" />
            )
        }
        else {
            return (
                <span></span>
            )
        }
    }
}


class AllAnunturiMobil extends React.Component {

    getCssClassName(anunt) {

        let classes = "licitatie-row";
        if ( JudeteDataService.licitatiiAllSelected === anunt.id ) {
            classes += " selected";
        }
        return classes;
    }

    // Deschid direct pagina de detalii
    handleAnuntClick(anuntId) {
        JudeteDataService.licitatiiAllSelected = anuntId;
        this.props.navigate("/licitatie/teren/" + anuntId );
    }

    render() {
        return (
            <div id="judete-container" className='unselectable' >
                
                <div id="header" className="licitatie-row unselectable">
                    <div onClick={ () => this.props.orderBy(ORDER_BY_ID) }>Id ↓</div>
                    <div className="all-licitatii-total-price-header" onClick={ () => this.props.orderBy(ORDER_BY_TOTAL_PRICE) }>Total ↓</div>
                    <div onClick={ () => this.props.orderBy(ORDER_BY_SURFACE) }>Surface↓</div>
                    <div onClick={ () => this.props.orderBy(ORDER_BY_MP_PRICE) }>P/mp ↓</div>
                    <div id="salvata-header"><Salvata salvata={1}/></div>
                </div>

                {this.props.anunturi.map( (anunt, index) => (
                    <div key={index} onClick={() => this.handleAnuntClick(anunt.id)} >
                        <div className={this.getCssClassName(anunt)}>
                            <div className='licitatie-id-smaller'>{anunt.id}</div>
                            <div className='all-licitatii-total-price'>{anunt.total_price}</div> 
                            <div>{anunt.surface}</div> 
                            <div>{ parseFloat(anunt.price_mp).toFixed(2)}</div> 
                            <div><Salvata salvata={anunt.salvata}/></div>
                        </div>
                    </div>
                ))}
            </div>
        )
    }
}

class AllAnunturiDesktop extends React.Component {
    // Expect to get props:
    // licitatie: true/false
    // desktop: true/false
    // for: casa/teren

    getCssClassName(anunt) {
        let classes = "licitatie-row desktop";

        // If marked as ignored by the user add "ignored" class
        if ( this.props.for === anunt.ignored_for_type && 
            this.props.licitatie === anunt.ignored_for_liciatatie) {
            classes += " ignore";                
        }

        if (this.props.for === 'teren' && !this.props.licitatie) {
            if (JudeteDataService.terenSelected === anunt.id) {
                classes += " selected";
            }
        }

        if (this.props.for === 'casa' && !this.props.licitatie) {
            if (JudeteDataService.casaSelected === anunt.id) {
                classes += " selected";
            }
        }

        return classes;
    }

    // Deschid direct pagina de detalii
    handleAnuntClick(anuntId) {
        if (this.props.for === 'teren') {
            if (this.props.licitatie) {
                this.props.navigate("/licitatie/teren/desktop/" + anuntId );
                JudeteDataService.licitatiiAllSelected = anuntId;
            } else {
                this.props.navigate("/anunt/teren/desktop/" + anuntId );
                JudeteDataService.terenSelected = anuntId;
            }
        }

        if (this.props.for === 'casa') {
            if (this.props.licitatie) {
                this.props.navigate("/licitatie/case/desktop/" + anuntId );
                JudeteDataService.licitatiiAllSelected = anuntId;
            } else {
                this.props.navigate("/anunt/case/desktop/" + anuntId );
                JudeteDataService.casaSelected = anuntId;
            }
        }

    }

    render() {
        return (

            <div id="judete-grid-container-desktop">
                {/* Coloana 1 */}
                <div></div> 

                {/* Coloana 2 */}
                <div id="judete-container" className='unselectable' >


                    {/* Input cautare */}
                    <div className='row mb-20'>
                        <div className='mr-20'>Localitate</div>
                        <div id='row-cautare' className='grow'>
                            <div id="card-search-input-all" className='unselectable'>
                                <input id="search-input-all" type='text' placeholder="Ex: Bucuresti" onChange={(e) => this.props.searchBy(e.target.value)}/>
                            </div>
                        </div>
                    </div>


                    {/* Header */}
                    <div id="header" className="licitatie-row desktop">
                        <div id="header-id" onClick={ () => this.props.orderBy(ORDER_BY_TOTAL_PRICE) }>ID ↓</div>
                        <div onClick={ () => this.props.orderBy(ORDER_BY_LOCALITATE) }>Localitate ↓</div>
                        <div onClick={ () => this.props.orderBy(ORDER_BY_TOTAL_PRICE) }>Total ↓</div>
                        <div onClick={ () => this.props.orderBy(ORDER_BY_SURFACE) }>Surface↓</div>
                        <div onClick={ () => this.props.orderBy(ORDER_BY_MP_PRICE) }>EUR/mp ↓</div>
                        <div><Salvata salvata={1}/></div>
                        <div><Raportata raportata={1}/></div>
                    </div>

                    {/* Randurile */}
                    {this.props.anunturi.map( (anunt, index) => (
                        <div key={index} onClick={() => this.handleAnuntClick(anunt.id)} >
                            <div className={this.getCssClassName(anunt)}>
                                <div className="id-wrapper">
                                    <div className='licitatie-id-smaller-desktop'>{anunt.id}</div>
                                </div>
                                <div>{anunt.localitate}</div> 
                                <div>{anunt.total_price}</div> 
                                <div>{anunt.surface}</div> 
                                <div>{ parseFloat(anunt.price_mp).toFixed(2)}</div> 
                                <div><Salvata salvata={anunt.salvata}/></div>
                                <div><Raportata raportata={anunt.raportata}/></div>
                            </div>
                        </div>
                    ))}

                    <div className='mt-20 mb-20'>
                        <div className='all-legend mb-15'><Salvata salvata={1}/><span className='ml-10'>Interesanta - Un fel de bookmark care se pastreaza de la zi la zi</span></div>
                        <div className='all-legend mb-15'><Raportata raportata={1}/><span className='ml-10'>Raportata - Semnaleaza mie ca datele sunt extrase gresit</span></div>
                        <div className='all-legend'>
                            
                            <div className="p-10 selected">
                                <div className="id-wrapper">
                                    <div className='licitatie-id-smaller-desktop'>X</div>
                                </div>
                            </div>
                        
                        <span className='ml-10'>Ultima selectata. Salvez separat teren/casa. Se reseteaza la refresh</span></div>
                    </div>

                </div>

                {/* Coloana 3 */}
                <div></div> 

            </div>
        )
    }
}

// Pentru a putea folose functia useNavigate, am facut un wrapper function peste componenta LicitatiiMobil
function AllAnunturiMobilWithNavigate(props) {
    let navigate = useNavigate();
    return <AllAnunturiMobil {...props} navigate={navigate} />
}

// Pentru a putea folose functia useNavigate, am facut un wrapper function peste componenta LicitatiiMobil
function AllAnunturiDesktopWithNavigate(props) {
    let navigate = useNavigate();
    return <AllAnunturiDesktop {...props} navigate={navigate} />
}

// Corespunde paginii tuturor licitatiilor dintr-un judet
// Expect to get props:
// licitatie: true/false
// desktop: true/false
// for: casa/teren
class AllAnunturi extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            all: [],
            filtered: [],
            count: 0,
            anunturiCount: 0,
            jud: "judet",
            search: '',
        }
    }

    componentDidMount() {
        const judet = this.props.params.judet;

        JudeteDataService.getRaportDataJudet(judet).then( response => {

            if (this.props.for === 'teren') {
                if (this.props.licitatie) {
                    this.setState({
                        all: response.licitatii_all,
                        filtered: response.licitatii_all,
                        count: response.licitatii_all.length,
                        anunturiCount: response.anunturi_count,
                        jud: judet
                    });
                    // JudeteDataService.licitatiiAll = response.licitatii_all;
                    // JudeteDataService.licitatiiAllJud = judet;
                    // JudeteDataService.licitatiiAllAnunturiCount = response.anunturi_count;
                } else {
                    this.setState({
                        all: response.anunturi_all,
                        filtered: response.anunturi_all,
                        count: response.anunturi_all.length,
                        anunturiCount: response.anunturi_count,
                        jud: judet
                    });
                    // Set cache here
                }
            } else if (this.props.for === 'casa') {
                if (this.props.licitatie) {
                    throw Error('Not implemented - nu am parsat licitatii pentru case');
                } else {
                    this.setState({
                        all: response.anunturi_case_all,
                        filtered: response.anunturi_case_all,
                        count: response.anunturi_case_all.length,
                        anunturiCount: response.anunturi_count,
                        jud: judet
                    });
                    // Set cache here
                }
            } else {
                    throw Error('for property not accepted: ' + this.props.for);
            }
        });

        // Salvez detele pentru a sti ce judet sa deschid in pagina principala
        JudeteDataService.dropJud = judet;

        window.scrollTo(0, 0);
    }

    orderBy(criteriu) {
        let sortedLicitatii;
        if ( criteriu === ORDER_BY_MP_PRICE ) {
            sortedLicitatii = this.state.filtered.sort( function( licitatieA, licitatieB ) {
                return licitatieA.price_mp - licitatieB.price_mp;
            });
        }
        
        if ( criteriu === ORDER_BY_SURFACE ) {
            sortedLicitatii = this.state.filtered.sort( function( licitatieA, licitatieB ) {
                return licitatieA.surface - licitatieB.surface;
            });
        }

        if ( criteriu === ORDER_BY_TOTAL_PRICE ) {
            sortedLicitatii = this.state.filtered.sort( function( licitatieA, licitatieB ) {
                return licitatieA.total_price - licitatieB.total_price;
            });
        }

        if ( criteriu === ORDER_BY_ID ) {
            sortedLicitatii = this.state.filtered.sort( function( licitatieA, licitatieB ) {
                return parseInt(licitatieA.id) - parseInt(licitatieB.id);
            });
        }

        if ( criteriu === ORDER_BY_LOCALITATE ) {
            sortedLicitatii = this.state.filtered.sort( function( licitatieA, licitatieB ) {
                return licitatieA.localitate.localeCompare(licitatieB.localitate, undefined, { sensitivity: 'base' });
            });
        }

        this.setState({
            filtered: sortedLicitatii,
        })
    }

    searchBy() {
        return (localitateFilter) => {
            if (localitateFilter.length === 0) {
                this.setState({
                    filtered: this.state.all,
                })
            } else {
                this.setState({
                    filtered: this.state.all.filter(x => x.localitate.toLowerCase().includes(localitateFilter.toLowerCase()))
                });
            }
        };
    }

    render() {
        const isMobile = window.innerWidth < 800;
        if ( isMobile ) {
            return (
                <div>
                    <TotaluriJudet anunturiCount={this.state.anunturiCount} licitatiiCount={this.state.count} jud={this.state.jud} />
                    <AllAnunturiMobilWithNavigate anunturi={this.state.filtered} orderBy={(c) => this.orderBy(c)} />
                </div>
            )
        }
        else {
            return (
                <div id='content-all'>
                    <div className='buttons-direction'>
                        <Link className='link' to={`/`}><div className="button-direction">Harta</div></Link>
                    </div>

                    <TotaluriJudet licitatie={this.props.licitatie} for={this.props.for} anunturiCount={this.state.anunturiCount} licitatiiCount={this.state.count} jud={this.state.jud} />
                    <AllAnunturiDesktopWithNavigate licitatie={this.props.licitatie} for={this.props.for} anunturi={this.state.filtered} orderBy={(c) => this.orderBy(c)} searchBy={this.searchBy()}/>
                </div>
            )
        }
    }
}

// eslint-disable-next-line
export default (props) => (
    <AllAnunturi {...props} params={useParams()} /> 
);